import { Component, OnInit ,TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoaImageService } from './../../services/soa-image.service';
import { DatePipe } from '@angular/common';
import { ContactService } from './../../services/contact.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import { FactoringTabService } from './../../services/factoring-tab.service';
import { EncrDecrService } from './../../services/encr-decr.service';
declare var $: any;

@Component({
  selector: 'app-factoring-tab2',
  templateUrl: './factoring-tab2.component.html',
  styleUrls: ['./factoring-tab2.component.css']
})
export class FactoringTab2Component implements OnInit {
    maxDate: Date;
    modalRef: BsModalRef;
    config :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
    };

    config1 :any = {
      animated: true,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-xl'
    };

    user_id: any='';
    company_id: any='';
    APIKEY:any= '';
    factTabList:any=[];
    customerList:object=[];
    customerModel:any = {};
    customerModel1:any = {};
    FactFolderList:any;
    mobileFolderList:any=[];
    temp_var:any=false;
    model:any={};
    customer_id:any='';
    invoice_id:any='';
    delete_id:any='';
    
    arrayOne(n: number): any[] {
      return Array(n);
    }
    pdfSrc:any='';


    masterSelected: boolean;
    checklist: any;
    multiSelect: boolean = false;
    isSelected: boolean = false;
    inEditMode = false;
    checkedList: any;
    checked: any;
    item: any;
    checkbox: any;
  
    Follow_list = [];
    data: any;
    emailModel:any={}; 
    folderid:any=0;
    loaderMode=false;
    create_soa_btn:boolean=true;

    emailModal:any=true;
    emailModalError:any=false;
    submitted = false;

    constructor(
      private modalService: BsModalService,
      private _factTap2: FactoringTabService,
      private _contact:ContactService,
      private _soaImage:SoaImageService,
      private _router : Router,
      private toastr: ToastrService,
      private _activatedroute: ActivatedRoute,
      private formBuilder: FormBuilder,
      private SoaImageService: SoaImageService,
      private _factInvoice:FactoringInvoiceService, 
      private datePipe:DatePipe,
      private EncrDecr: EncrDecrService) {}

    ngOnInit() {
      this.user_id =localStorage.getItem('id');
      this.company_id =localStorage.getItem('company_id');
      this.APIKEY =localStorage.getItem('APIKEY');
      /////////// s code
      this.customerList = [];
      this.checkbox = [];
      this.data = [];
      this.item = [];

      this.getfactInvoice();

      //get customer for mobile and other role user
      const customerModal={
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id,
        status: 'active',
      }
      this._contact.getContactList(customerModal)
      .subscribe(
        res => { 
            this.customerModel['customer']=0;
            this.customerList=res;
        }, 
      );

      this.maxDate = new Date() ;
 }


 onMasterSmallSelect(i, $event) {
   if ($event.target.checked == true) {
       $('.checkImageAllOpn'+i).prop("checked",true);
   } else {
       $('.checkImageAllOpn'+i).prop("checked",false);
   }
 }

 onCheckUser(i,$event){
      var checkvalue=0;
      var checkvalueNum=0;
      $('.checkImageAllOpn'+i).each(function() {
          checkvalueNum++;
          if($(this).prop("checked") == true){
             checkvalue++;
          }
       });
       if(checkvalueNum==checkvalue){
             $('.master_small'+i).prop("checked",true);
       }
       else{
             $('.master_small'+i).prop("checked",false);
       }
 }

 checkUncheckAll($event){
    if ($event.target.checked == true) {
        $('.checkUncheckAll').prop("checked",true);
    } else {
        $('.checkUncheckAll').prop("checked",false);
    }
 }

onSubmitCustomer(){
    const a=  this.customerModel.customer;
    const b = $(".select2").val();
    //console.log('bbbbbbb',b) ;
    if(b==''|| b==0){
      this.submitted = true;
      console.log('submitted',this.submitted) ;
      return false ;
    }

    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), b); 

    this._router.navigateByUrl('/mobile/add-mobile/existing/'+encrypted);
    this.modalRef.hide();
  } 

 getCustomerEmail(customer_id,invoice_id){  this.emailModalError=false;
 // this.loaderMode=true;
   this.invoice_id=invoice_id;
   const folderModel={
     APIKEY : this.APIKEY,
     user_id : this.user_id,
     company_id : this.company_id,
     customer_id : customer_id,
   }
   
   this._contact.getContactEmailsByid(folderModel).subscribe(
     res => { 
        console.log(res.data);  
        this.emailModel=res.data;
      },
   );
}


sendEmailToCust(){
  const folderModel={
    APIKEY : this.APIKEY,
    user_id : this.user_id,
    company_id : this.company_id,
    email_info : this.emailModel,
    invoice_id:this.invoice_id
  }

  
  this._factInvoice.sendEmailToCustomer(folderModel).subscribe(
    res => {        
            
            
            this.modalRef.hide();
            if(res.status==true){
            this.toastr.success(res.message, 'Success');
          } else {
            this.toastr.error(res.message, 'Error');
          }
            this.emailModal=false;
            this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab1');
            });
    },
    err => console.log(err)
  );
  /*if(this.emailModal){
    const rload=this;
    setTimeout(function(){  rload.emailModalError=true;}, 1500);
     
  }*/
  
}




getfactInvoice(){
     this.loaderMode=true;;
     ///////get factoring invoice
      const invoiceModal={
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        customer_id : this.customer_id,
        company_id : this.company_id,
        status: 'approved',
      }
      //console.log(customerModal);
      this._factTap2.getFactFolderList(invoiceModal)
      .subscribe(
        res => { 
    //console.log(res)
            this.factTabList=res;
            this.temp_var=true;
            this.loaderMode=false;
        },
      );  
     ////end 
  

}

    
    showSelectedData() {


      var select_fact_array = [];
      $(".checkImageAllOpn:checked").each(function() {
           select_fact_array.push($(this).val());
      });
      

      select_fact_array.length;
      if(select_fact_array.length==0){
           alert('Minimum one invoice is required');
           return false;
      }
      else{
          this.loaderMode=true;
          this.create_soa_btn=false;

      }


       // alert(select_fact_array);

      const customerModal={
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id,
        fact_invoice_id: select_fact_array,
      }
      this._factInvoice.createFactoringSoa(customerModal)
      .subscribe(
        res => { 
          console.log(res); 
          this.create_soa_btn=true;
          this.loaderMode=false;
          var pdf_path=  res.data.pdf_path;

          var soa_id=  res.data.soa_id;
          //console.log(soa_id);


         // var csv_link=  res.data.csv_link;
         var encrypted_company_id = this.EncrDecr.set('123456$#@$^@1ERF', this.company_id);
         var encrypted_soa_id = this.EncrDecr.set('123456$#@$^@1ERF', soa_id);
      
         this.sendEmailFactoringSoa(encrypted_company_id,encrypted_soa_id,soa_id);
        
        }, 
        err =>{
          console.log(err);
        }
      );
      ////end  
    }
  
    
    sendEmailFactoringSoa(encrypted_company_id,encrypted_soa_id,soa_id){
      const soaModal={
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id,
        encrypted_company_id : encrypted_company_id,
        encrypted_soa_id : encrypted_soa_id,
        soa_id : soa_id,
      }
      this._factInvoice.sendEmailFactoringSoa(soaModal)
      .subscribe(
        res => { 
        //   console.log(res);
           //  this.ngOnInit();
            if(res.status==true){
              this.toastr.success(res.message, 'Success');
            } else {
              this.toastr.error(res.message, 'Error');
            }
            
           this._router.navigateByUrl('/redirect').then(() => {
              this._router.navigateByUrl('/factoring/factoring-tab2');
           });
        }, 
      );


    }
    


    openModal(template: TemplateRef<any>) {

      $(function(){ 
        $(".select2").select2({
           placeholder: "Select"
        });
      });

      this.modalRef = this.modalService.show(template,this.config); 
    } 

    openModal1(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(template,this.config1); 
    } 
  

 setpdfSrc(src)
 {
     this.pdfSrc=src;
 }

     
  editfactSoa(rec) {
     const folderModel={
          APIKEY : this.APIKEY,
          user_id : this.user_id,
          company_id : this.company_id,
          mobile_id : rec,
        }
        this._factInvoice.getFolderInfo(folderModel)
      .subscribe(
        res => { 
              this.model=res.data;
              this.model['date_invoice']= this.datePipe.transform(res.data.date_invoice, 'MM/dd/yyyy');
              this.model['work_week']= this.datePipe.transform(res.data.work_week, 'MM/dd/yyyy');
              this.model['terms']=res.data.factterms;
             // console.log(this.model);
        },
      );  
      }

    onSubmitSoaFolder ()
    {
       this.model['APIKEY']=this.APIKEY;
       this.model['user_id']=this.user_id;
       this.model['company_id']=this.company_id;
       this.model['mode']='edit';
       this.model['folder_id']=this.model['id']; 
       this.model['invoice_id']=this.model['fact_invoice_id']
     // console.log(this.model);  return false;
  
      this.model['date_invoice']= this.datePipe.transform(this.model['date_invoice'], 'MM/dd/yyyy, hh:mm a');
      this.model['work_week']= this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');
     
      // console.log(this.model['date_invoice']);  return false;
       
      //console.log(this.model);  return false;
  
     this._factInvoice.factInvoiceSave(this.model).subscribe(
        res => { 
          this.modalRef.hide();
           this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab1');
           });
          },
      ); 
   }  

 set_delete_id(cid){
    this.delete_id = cid;
 }

 sendEmail(){
     alert('vvvv');


 }




 delete_user(){
  const data ={
    invoice_id:this.delete_id,
    company_id:this.company_id,
    APIKEY:this.APIKEY,
    user_id:this.user_id,
  }

  this._factInvoice.deleteFactInvoice(data)
    .subscribe(
      res => {
       // console.log(res);
       // this.ngOnInit();
        this.toastr.success(res.message, 'Success');
         this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab1');
         });
      },
      err => console.log(err)
    );
  }
  

  onChangeCust(value){
    this.customer_id= value;
    this.getfactInvoice();
  }

  onChangeFactStatus(value){  //alert(value);
    const data ={
        invoice_id:value,
        APIKEY:this.APIKEY,
        user_id:this.user_id,
        status:'opted_out',
     }
  
    this._factInvoice.changeFactoringStatus(data)
      .subscribe(
        res => {
         console.log(res);
         // this.ngOnInit();
          this.toastr.success(res.message, 'Success');
           this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/factoring/factoring-tab1');
           });
        },
        err => console.log(err)
      );
  }

omit_special_char(event)
{  
  // alert('ccc'); 
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   //alert(k);
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57)); 
}


isNumberKey(evt)
{
   var charCode = (evt.which) ? evt.which : evt.keyCode;
   
   if (charCode != 46 && charCode > 31 
     && (charCode < 48 || charCode > 57))
      return false;

   return true;
}

}
